/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const AccountCircleLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m.16 14c-2.04 0-3.87.87-5.15 2.26a8 8 0 0 0 10.16-.15A7 7 0 0 0 12.16 16M12 4a8 8 0 0 0-6.38 12.82 8.97 8.97 0 0 1 12.9-.19A8 8 0 0 0 12 4m0 1a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
  </Icon>
);
